import React, { ChangeEvent, SetStateAction, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CSSObjectWithLabel } from 'react-select/dist/declarations/src/types'
import { Box, Box as FormRow } from '@node-space/storybook-components/dist/Box'
import Button from '@node-space/storybook-components/dist/Button'
import { DatePicker } from '@node-space/storybook-components/dist/DatePicker'
import IconSelect from '@node-space/storybook-components/dist/IconSelect'
import { Search } from '@node-space/storybook-components/dist/Search'
import Select from '@node-space/storybook-components/dist/Select'
import { Text } from '@node-space/storybook-components/dist/Text'
import { DateFormat } from 'constants/General'
import type { IDateValue, SelectOption } from 'types/types'

const extendDropdownStyles = {
  container: (base: CSSObjectWithLabel) => ({
    ...base,
    height: '40px',
  }),
}

interface ApprovalFilterBarProps {
  searchTerm: string
  onSearchTermChange: (e: ChangeEvent<HTMLInputElement>) => void
  searchCurrency: string
  onSearchCurrencyChange: React.Dispatch<SetStateAction<string>>
  initiatorOptions: { label: string; value: string }[]
  isBeingSearched?: boolean
  isFetchingApprovalTransactions?: boolean
  currencyOptions?: SelectOption[]
}

// TODO: search functionality with BE integration in phase 3
const ApprovalFilterBar = ({
  searchTerm,
  onSearchTermChange,
  onSearchCurrencyChange,
  searchCurrency,
  initiatorOptions,
  isBeingSearched = false,
  isFetchingApprovalTransactions = false,
  currencyOptions,
}: ApprovalFilterBarProps) => {
  const { t } = useTranslation()

  const [dateValue, setDateValue] = useState<IDateValue>({
    startDate: null,
    endDate: null,
  })

  const onDateSelected = (dateVal: IDateValue) => {
    setDateValue(dateVal)
  }

  return (
    <Box paddingT={16} paddingB={8} gapX={16} flex flexWrap>
      <FormRow width="full" className="lg:w-2/5 pb-3" gapY={12}>
        <Search
          onChange={onSearchTermChange}
          placeholderText={t('approvals.searchPlaceholder')}
          searchTerm={searchTerm}
          size="sm"
          textSize="sm"
        />
      </FormRow>
      <FormRow width="full" className="lg:w-48 pb-3" gapY={12}>
        <DatePicker
          dateRange
          dateFieldPlaceholder={t('approvals.dateRange')}
          dateValue={dateValue}
          onDateValueChange={dateVal => onDateSelected(dateVal)}
          dateRangeSeparator="-"
          maxDate={new Date()}
          enableDateFieldEdit={false}
          displayFormat={DateFormat.DD_MMM_YYYY}
        />
      </FormRow>
      <FormRow width="full" className="lg:w-48 pb-3" gapY={12}>
        <IconSelect
          iconsUrl={process.env.ICONS_URL}
          menuMaxHeight={300}
          value={searchCurrency}
          onChange={value => {
            onSearchCurrencyChange(value)
          }}
          options={currencyOptions}
          placeholder={t('currency')}
          disabled={!!!currencyOptions?.length}
          extendStyles={extendDropdownStyles}
        />
      </FormRow>
      <FormRow width="full" className="lg:w-48 pb-3">
        <Select
          options={initiatorOptions}
          placeholder={t('approvals.initiator')}
          extendStyles={extendDropdownStyles}
        />
      </FormRow>
      {isBeingSearched && !isFetchingApprovalTransactions && (
        <Box flex centerChildren justifyContent="center">
          <Button
            noStyling
            onClick={() => {
              onSearchCurrencyChange('')
            }}
          >
            <Text size="sm" color="primary-500">
              {t('clearFilters')}
            </Text>
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default ApprovalFilterBar
